export default {
  methods: {
    setSessionItem(key, value) {
      sessionStorage.setItem(key, JSON.stringify(value));
    },
    getSessionItem(key) {
      const item = sessionStorage.getItem(key);
      if (item) {
        return JSON.parse(item);
      }
      return item;
    },
  },
};
